import '@quasar/extras/material-icons/material-icons.css';
import '@quasar/extras/mdi-v5/mdi-v5.css';
import {
  Dialog,
  LocalStorage,
  Meta,
  Notify,
  ClosePopup,
  Intersection,
  QInput,
  QBtn,
  QCard,
  QCardSection,
  QCardActions,
  QDialog,
  QForm,
  QIcon,
  QCheckbox,
  QSelect,
  QTooltip,
  QMenu,
  QList,
  QItem,
  QItemSection,
  QItemLabel,
  QSeparator,
  QSpinner,
  QTable,
  QTabs,
  QTab,
  QTabPanels,
  QTabPanel,
  QToggle,
  QRadio,
  QBadge,
  QChip,
  QAvatar,
  QScrollArea,
  QVirtualScroll,
  QInfiniteScroll,
  QLinearProgress,
  QCircularProgress,
  QSkeleton,
  QExpansionItem,
  QTree,
  QPopupProxy,
  QDate,
  QTime,
  QField,
  QOptionGroup,
  QSlider,
  QRange,
  QRating,
  QUploader,
  QBtnDropdown,
  QBtnGroup,
  QBtnToggle,
  QBar,
  QSpace,
  QToolbar,
  QToolbarTitle,
  QHeader,
  QFooter,
  QDrawer,
  QPageContainer,
  QPage,
  QPageSticky,
  QLayout,
  QAjaxBar,
  QNoSsr,
  QPagination,
  QBreadcrumbs,
  QBreadcrumbsEl,
  QBanner,
  QEditor,
  QFab,
  QFabAction,
  QKnob,
  QMarkupTable,
  QParallax,
  QInnerLoading,
  QVideo,
  QChatMessage,
  QTimeline,
  QTimelineEntry,
  QCarousel,
  QCarouselControl,
  QCarouselSlide,
  QImg,
  QIntersection,
  QSplitter,
  QStep,
  QStepper,
  QStepperNavigation,
  QRouteTab,
  QResizeObserver,
  QResponsive,
  QSlideTransition,
  QSlideItem,
  QPullToRefresh,
} from 'quasar';

export default {
  config: {
    brand: {
      primary: '#027BE3',
      secondary: '#26A69A',
      accent: '#9C27B0',
      dark: '#1D1D1D',
      positive: '#21BA45',
      negative: '#21BA45',
      info: '#21BA45',
      warning: '#F2C037',
    },
    globalProperties: {},
    // dark: true
  },
  plugins: {
    LocalStorage,
    Notify,
    Dialog,
    Meta,
  },
  directives: {
    ClosePopup,
    Intersection,
  },
  components: {
    QInput,
    QBtn,
    QCard,
    QCardSection,
    QCardActions,
    QDialog,
    QForm,
    QIcon,
    QCheckbox,
    QSelect,
    QTooltip,
    QMenu,
    QList,
    QItem,
    QItemSection,
    QItemLabel,
    QSeparator,
    QSpinner,
    QTable,
    QTabs,
    QTab,
    QTabPanels,
    QTabPanel,
    QToggle,
    QRadio,
    QBadge,
    QChip,
    QAvatar,
    QScrollArea,
    QVirtualScroll,
    QInfiniteScroll,
    QLinearProgress,
    QCircularProgress,
    QSkeleton,
    QExpansionItem,
    QTree,
    QPopupProxy,
    QDate,
    QTime,
    QField,
    QOptionGroup,
    QSlider,
    QRange,
    QRating,
    QUploader,
    QBtnDropdown,
    QBtnGroup,
    QBtnToggle,
    QBar,
    QSpace,
    QToolbar,
    QToolbarTitle,
    QHeader,
    QFooter,
    QDrawer,
    QPageContainer,
    QPage,
    QPageSticky,
    QLayout,
    QAjaxBar,
    QNoSsr,
    QPagination,
    QBreadcrumbs,
    QBreadcrumbsEl,
    QBanner,
    QEditor,
    QFab,
    QFabAction,
    QKnob,
    QMarkupTable,
    QParallax,
    QInnerLoading,
    QVideo,
    QChatMessage,
    QTimeline,
    QTimelineEntry,
    QCarousel,
    QCarouselControl,
    QCarouselSlide,
    QImg,
    QIntersection,
    QSplitter,
    QStep,
    QStepper,
    QStepperNavigation,
    QRouteTab,
    QResizeObserver,
    QResponsive,
    QSlideTransition,
    QSlideItem,
    QPullToRefresh,
  },
};
